export type NLDivision = "All";

export interface NLTeam {
  id: string;
  name: string;
  nameDe: string;
  abbr: string;
  city: string;
  logo: string;
  division: NLDivision;
}

// Swiss National League team logos from TheSportsDB
const NL_LOGOS: Record<string, string> = {
  "1": "https://r2.thesportsdb.com/images/media/team/badge/xnk2pv1656778452.png",   // ZSC Lions
  "2": "https://r2.thesportsdb.com/images/media/team/badge/4vpv5y1656778361.png",   // SC Bern
  "3": "https://r2.thesportsdb.com/images/media/team/badge/x1bcq71656778399.png",   // EV Zug
  "4": "https://r2.thesportsdb.com/images/media/team/badge/bq53vc1656778282.png",   // HC Davos
  "5": "https://r2.thesportsdb.com/images/media/team/badge/8nfnf61656778318.png",   // Lausanne HC
  "6": "https://r2.thesportsdb.com/images/media/team/badge/b2gdz41656778234.png",   // Fribourg-Gottéron
  "7": "https://r2.thesportsdb.com/images/media/team/badge/39vhqc1656778347.png",   // Rapperswil-Jona
  "8": "https://r2.thesportsdb.com/images/media/team/badge/bxfwj01656778186.png",   // EHC Biel
  "9": "https://r2.thesportsdb.com/images/media/team/badge/o2qzqj1656778332.png",   // HC Lugano
  "10": "https://r2.thesportsdb.com/images/media/team/badge/r95y6b1656778244.png",  // Genève-Servette
  "11": "https://r2.thesportsdb.com/images/media/team/badge/oihx671656778157.png",  // Ambri-Piotta
  "12": "https://r2.thesportsdb.com/images/media/team/badge/xsn7a31656778167.png",  // HC Ajoie
  "13": "https://r2.thesportsdb.com/images/media/team/badge/hj4a561656778300.png",  // EHC Kloten
  "14": "https://r2.thesportsdb.com/images/media/team/badge/xq0a781656778378.png",  // SCL Tigers
};

const getNLLogo = (teamId: string) => NL_LOGOS[teamId] ?? "";

export const NL_TEAMS: NLTeam[] = [
  { id: "1", name: "ZSC Lions", nameDe: "ZSC Lions", abbr: "ZSC", city: "Zürich", logo: getNLLogo("1"), division: "All" },
  { id: "2", name: "SC Bern", nameDe: "SC Bern", abbr: "SCB", city: "Bern", logo: getNLLogo("2"), division: "All" },
  { id: "3", name: "EV Zug", nameDe: "EV Zug", abbr: "EVZ", city: "Zug", logo: getNLLogo("3"), division: "All" },
  { id: "4", name: "HC Davos", nameDe: "HC Davos", abbr: "HCD", city: "Davos", logo: getNLLogo("4"), division: "All" },
  { id: "5", name: "Lausanne HC", nameDe: "Lausanne HC", abbr: "LHC", city: "Lausanne", logo: getNLLogo("5"), division: "All" },
  { id: "6", name: "HC Fribourg-Gottéron", nameDe: "HC Fribourg-Gottéron", abbr: "FRI", city: "Fribourg", logo: getNLLogo("6"), division: "All" },
  { id: "7", name: "SC Rapperswil-Jona Lakers", nameDe: "SC Rapperswil-Jona Lakers", abbr: "SCRJ", city: "Rapperswil", logo: getNLLogo("7"), division: "All" },
  { id: "8", name: "EHC Biel", nameDe: "EHC Biel", abbr: "BIE", city: "Biel", logo: getNLLogo("8"), division: "All" },
  { id: "9", name: "HC Lugano", nameDe: "HC Lugano", abbr: "LUG", city: "Lugano", logo: getNLLogo("9"), division: "All" },
  { id: "10", name: "Genève-Servette HC", nameDe: "Genève-Servette HC", abbr: "GEN", city: "Geneva", logo: getNLLogo("10"), division: "All" },
  { id: "11", name: "HC Ambri-Piotta", nameDe: "HC Ambri-Piotta", abbr: "AMB", city: "Ambri", logo: getNLLogo("11"), division: "All" },
  { id: "12", name: "HC Ajoie", nameDe: "HC Ajoie", abbr: "AJO", city: "Porrentruy", logo: getNLLogo("12"), division: "All" },
  { id: "13", name: "EHC Kloten", nameDe: "EHC Kloten", abbr: "KLO", city: "Kloten", logo: getNLLogo("13"), division: "All" },
  { id: "14", name: "SCL Tigers", nameDe: "SCL Tigers", abbr: "SCL", city: "Langnau", logo: getNLLogo("14"), division: "All" },
];

export const NL_DIVISIONS: NLDivision[] = ["All"];

export const getNLTeamByAbbr = (abbr: string): NLTeam | undefined => {
  return NL_TEAMS.find((team) => team.abbr === abbr);
};
